module.exports = __webpack_public_path__ + "img/2.0d52e856.png";